import React, { useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import {withRouter, useHistory } from 'react-router-dom'
import {auth, updateProfile, createUserWithEmailAndPassword,sendPasswordResetEmail, signInWithEmailAndPassword} from '../../FirebaseInit'

import {Container as ContainerBase} from "components/misc/Layouts";

import logo from "images/logo.png";
import {ReactComponent as LoginIcon} from "feather-icons/dist/icons/log-in.svg";



const Container = tw(
  ContainerBase
)`min-h-screen text-white font-medium flex justify-center -m-8`;
const Content = tw.div`max-w-screen-xl m-0 sm:mx-20 sm:my-16 bg-white text-gray-900 shadow sm:rounded-lg flex justify-center flex-1`;
const Text = tw.text`mx-2 cursor-pointer`;
const MainContainer = tw.div`lg:w-1/2 xl:w-5/12 p-6 sm:p-12`;
const LogoLink = tw.a`mb-10`;
const LogoImage = tw.img`h-12 mx-auto`;
const MainContent = tw.div`mt-12 flex flex-col items-center`;
const Heading = tw.h1`text-2xl xl:text-3xl font-extrabold`;
const FormContainer = tw.div`w-full flex-1 mt-8`;
const Form = tw.form`mx-auto max-w-xs mt-20`;
const Input = tw.input`w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5 first:mt-0`;

const SubmitButton = styled.button`
  ${tw`mt-5 tracking-wide font-semibold bg-yellow-600 text-gray-100 w-full py-4 rounded-lg transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none`}
  .icon {
    ${tw`w-6 h-6 -ml-2`}
  }
  .text {
    ${tw`ml-3`}
  }
`;

export default withRouter(({
  logoLinkUrl = "#",
  headingText = "Sign In To",
  SubmitButtonIcon = LoginIcon,
  forgotPasswordUrl = "#"
  
}) => {

  const history = useHistory ()

  const [newUser, setNewUser] = useState(true)
  const [signUp, setSignUp] = useState(false)
  const [email, setEmail] = useState("")
  const [emailErr, setEmailErr] = useState("")
  const [password, setPassword] = useState("")
  const [passwordErr, setPasswordErr] = useState("")
  const [submitErr, setSubmitErr] = useState("")
  const [forGotMailErr, setForGotMailErr] = useState("")
  const [username, setUsername] = useState("")
  const [usernameErr, setUsernameErr] = useState("")
  const [newUserMailIdErr, setNewUserMailIdErr] = useState("")
  const [newUserPassErr, setNewUserPassErr] = useState("")

  const EmailValidation=(e)=>{
  var mail=e.target.value

if(mail.length===0){
  setEmailErr("can't be empty")
}
   else if( !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-]+/.test(mail))
   {
     setEmailErr("Enter valid id")
   }
   else 
   {
    setEmailErr("")
    setEmail(mail)
   }
  }
  const PasswordChange=(value)=>{

    if(value.length ===0){
     
      setPasswordErr("you empty")
     

    }
    else if(value.length<8){
      setPasswordErr("enter more then eight")

    }else{
      setPasswordErr("")
      setPassword(value)
    }
    
  }
  const userNameFun=(e)=>{
    let username =e.target.value
    if(username===0){
      setUsernameErr("can't be empty")

    }
    else{
      setUsernameErr("")
      setUsername(username)
    }
  }
  const newUserEmailId=(e)=>{
    let mal=e.target.value

    if(mal===0){
      setNewUserMailIdErr("can't be empty")

    }
    else if(!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-]+/.test(mal)){
      setNewUserMailIdErr("Enter valid id")
    }
    else {
      console.log(mal,'mal');
      setNewUserMailIdErr("")
      setEmail(mal)
    }
  }
  const newUserPasswordFun=(e)=>{
    let password = e.target.value
    if(password===0){
      setNewUserPassErr("can't be empty")

    }
    else if(password<8){
      setNewUserPassErr("must be 8 letters")
    }else{
      setNewUserPassErr("")
      console.log(password, 'pass');
      setPassword(password)
    }
  }
  const registerUserFunction=async(e)=>
  {
    e.preventDefault()
    createUserWithEmailAndPassword(auth, email, password).then(() => {
      updateProfile(auth.currentUser, {
        displayName: username,
      })
      setEmailErr("")
      setSubmitErr("")
      setEmail('')
      setPassword('')
      setUsername('')
      setSignUp(false)
   }).catch(e => {
     console.log(e.message);
     setSubmitErr(e.message)
    })
    }
  const signInUserFunction=(e)=>
  {
    e.preventDefault()
    console.log(email, password);
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        console.log(user);
        setEmailErr("");
        setSubmitErr("");
        setEmail('');
        setPassword('');
        setUsername('');
        history.push("/")
        
      })
      .catch((error) => {
        console.log(error.message);
        setSubmitErr(error.message)
      });
   
    }
   const onClickChangePassword=(e)=>
    {
     e.preventDefault()
     if (email.length > 0) {
       setForGotMailErr('')
       sendPasswordResetEmail(auth, email).then(() => {
         setEmail('')
         setSignUp(false)
         setNewUser(true)
       }).catch(e => {
         setSubmitErr(e.message)
       })
     } else if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-]+/.test(email)) {
       console.log(email);
       setForGotMailErr(`Enter valid id`)
     }
     else {
       setForGotMailErr(`email Can't be empty`)
     }


}
  return (
    <>
   
      <Container>
        <Content>
          <MainContainer>
            <MainContent>
              {newUser ? <Heading>{headingText}</Heading> : ""}

              <FormContainer>
                <LogoLink href={logoLinkUrl}>
                  <LogoImage src={logo} />
                </LogoLink>

                {!signUp&&newUser ?
                  <><Form>
                    <Input type="email" name="email" onChange={(e)=>EmailValidation(e)} placeholder="Email" />
                    <span>{emailErr}</span>
                    <Input type="password" onChange={(e)=>PasswordChange(e.target.value)} placeholder="Password" />
                    <span tw="text-xs text-red-400" >{passwordErr}</span><br/>
                   
                    <span tw="text-xs text-red-400" >{submitErr}</span>
                      <SubmitButton onClick={(e)=>signInUserFunction(e)} type="submit">
                        <SubmitButtonIcon className="icon" />
                        <span className="text">Sign In</span>
                      </SubmitButton>
                  
                  </Form>
                    <p onClick={() => setNewUser(false)} tw="mt-6 text-xs text-gray-600 text-center">
                      <text
                        tw="border-b cursor-pointer border-gray-500 border-dotted"
                      >
                        Forgot Password ?
               </text>
                    </p>
                    <p tw="mt-8 text-sm text-gray-600 text-center">
                      Dont have an account?
                      <Text to="" onClick={()=>setSignUp(true)} tw="border-b border-gray-500 border-dotted">
                        Sign Up
                     </Text>
                    </p>
                  </> : !signUp ?
                  <>  
                  <Input type="email" onChange={(e)=>setEmail(e.target.value)} placeholder="Email" />
                      {forGotMailErr && <span tw="text-xs text-red-400" >{forGotMailErr}</span>}
                      <span tw="text-xs text-red-400" >{submitErr}</span>
                  <SubmitButton onClick={(e)=>onClickChangePassword(e)} type="submit">Submit</SubmitButton>
                  </> :null}

                 {signUp ? <><Form>
                    <Input onChange={(e)=>userNameFun(e)} type="text" placeholder="Name" />
                    <span>{usernameErr}</span>
                    <Input onChange={(e)=>newUserEmailId(e)} type="email" placeholder="Email" />
                    <span>{newUserMailIdErr}</span>
                    <Input onChange={(e)=>newUserPasswordFun(e)} type="password" placeholder="Password" />
                  <span>{submitErr}</span>
              
                      <SubmitButton type="submit" onClick={(e)=>registerUserFunction(e)}>
                        <SubmitButtonIcon className="icon" />
                      <span className="text">Sign Up</span>
                      </SubmitButton>
                   
                  </Form>
                    <p tw="mt-8 text-sm text-gray-600 text-center">
                      You have an account?
                      <Text onClick={()=>setSignUp(false)} tw="border-b border-gray-500 border-dotted">
                        Sign In
               </Text>
                    </p>
                  </> : "" } 
              </FormContainer>
            </MainContent>
          </MainContainer>
        </Content>
      </Container>



    </>
  )
}
)


